module.exports = __webpack_public_path__ + "img/lightLava.eddaac25.jpg";